export const TeamContent = () => {
    return (
        <section className="section-shell">
            <div className="section-block">
                <p className="section-body mb-8">
                    Our team members have expanded drastically over the years in
                    Kuala Lumpur, Johor Bahru, Melaka & Ipoh. We have
                    successfully nurture a group of young entrepreneurs in
                    pioneering the real estate career.
                </p>
                <img
                    className="w-full h-auto"
                    src="https://ik.imagekit.io/dnddecpho/dndream/D&D_WebsiteExtract_LocationsAll_0RVPTddJ0.png?updatedAt=1739982524411"
                    alt=""
                />
            </div>

            <div className="section-block section-block--wide">
                <h2 className="section-title">SALES DIRECTORS</h2>
                <img
                    className="w-full h-auto"
                    src="https://venti-fans.com/wp-content/uploads/2026/04/DD_Website_SD2026.png"
                    alt=""
                />
            </div>

            <div className="section-block section-block--wide">
                <h2 className="section-title">PROJECT DIRECTORS</h2>
                <img
                    className="w-full h-auto"
                    src="https://venti-fans.com/wp-content/uploads/2026/04/DD_Website_PD2026.png"
                    alt=""
                />
            </div>

            <div className="stat-row">
                <div>
                    <div className="section-stat">252</div>
                    <div className="stat-row-label">LEADERS</div>
                </div>
                <div>
                    <div className="section-stat">112</div>
                    <div className="stat-row-label">PROJECT COORDINATORS</div>
                </div>
            </div>

            <div className="section-block section-block--wide">
                <h2 className="section-title">D&D TRAINERS</h2>
                <img
                    className="w-full h-auto"
                    src="https://venti-fans.com/wp-content/uploads/2026/04/DD_Website_Trainer2026.png"
                    alt=""
                />
            </div>
        </section>
    );
};
